import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { Y42FeatureType } from '@y42/json-schema';
import { CatalogGitFactoryService } from './catalog-git-factory.service';
import { CatalogState } from './catalog.model';

const initialState: CatalogState = {
  loading: true,
  last_used: {},
  starred: {},
  active: null,
  ui: {},
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'catalog' })
export class CatalogStore extends AbstractFeatureEntityStore<CatalogState> {
  constructor(protected readonly gitFactory: CatalogGitFactoryService) {
    super({
      name: Y42FeatureType.Catalog,
      gitFactory,
      initialState,
    });
  }
}
